
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { getAuth, onAuthStateChanged, User } from 'firebase/auth';
import { filter } from 'rxjs';
import { UserService } from '../../services/users/user.service';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterModule, TranslatePipe],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {

  isAboutPage: boolean = false;
  hideSidebar = false;
  showTeamsSubmenu = false;
  showHappyHolydays = false;
  isAuthUserAdmin: boolean | null = null;
  isAuthUserAuthority: boolean | null = null;
  isAuthUserBusiness: boolean | null = null;

  currentUser: User | null = null;

  constructor(
    private router: Router,
    private userService: UserService
  ) {
    // Detect route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleRouteChange(event.urlAfterRedirects);
      });

    this.checkHolidayPeriod();
  }

  toggleTeamsSubmenu() {
    this.showTeamsSubmenu = !this.showTeamsSubmenu;
  }

  ngOnInit(): void {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.currentUser = user;

      if (user) {
        // Limpar cache do serviço antes de verificar
        this.userService.clearRolesCache();

        this.userService.isUserAuthAdmin().then(isAdmin => this.isAuthUserAdmin = isAdmin);
        this.userService.isUserAuthAuthority().then(isAuthority => this.isAuthUserAuthority = isAuthority);
        this.userService.isUserAuthBusiness().then(isBusiness => this.isAuthUserBusiness = isBusiness);
      } else {
        this.isAuthUserAdmin = false;
        this.isAuthUserAuthority = false;
        this.isAuthUserBusiness = false;
      }
    });
  }

  // Mantem o sub-menu aberto caso seja uma página relacionada com as equipas
  private handleRouteChange(url: string) {
    if (url.startsWith('/teams')) {
      this.showTeamsSubmenu = true;
    } else {
      this.showTeamsSubmenu = false;
    }
  }

  // função para verificar se estamos em preiodo de festa e mostrar a imagem de boas festas
  private checkHolidayPeriod() {
    const today = new Date();
    const month = today.getMonth() + 1; // Janeiro = 0, Dezembro = 11
    const day = today.getDate();

    // Entre 1 de Dezembro e 10 de Janeiro
    if ((month === 12 && day >= 1) || (month === 1 && day <= 10)) {
      this.showHappyHolydays = true;
    } else {
      this.showHappyHolydays = false;
    }
  }
}